import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className='notFound'>
            <h1>404 Not Found</h1>
            <img src="https://i0.wp.com/learn.onemonth.com/wp-content/uploads/2017/08/1-10.png?fit=845%2C503&ssl=1" alt="" />
        </div>
    );
};

export default NotFound;